import React, { Component, Fragment } from "react";
import List from "./List";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import { Link } from "react-router-dom";

import {
    records,
    record,
    remove,
    writerSearch,
    filter,
    getWriterRecords
} from "../../../services/employerApplicant";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import DashboardLeftPanel from "../account/DashboardLeftPanel";

class Writers extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        filter: false,
        search: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all",
        loadWriters:false
    };
    delete = id => {
        return remove(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };
    record = id => {
        return record(id);
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };
    search = query => {
        this.setState({ loading: true });
        writerSearch(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    filter = item => {
        this.setState({ loading: true });
        filter(item).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                filter: true,
                loading: false,
                filterItem: item
            });
        });
    };
    clear = () => {
        this.setState({ loading: true });
        getWriterRecords(0)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };
    rerender = (id=0) => {
        getWriterRecords(id)
        .then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                loading: false
            });
        })
        .catch(error => {
            this.context.state.handelError(error);
        });
      };
    componentDidMount() {
        let search = window.location.search;
        let params = new URLSearchParams(search).get('job');
        if(params && localStorage.getItem("loadWriters") !== null){
            this.rerender(localStorage.getItem("loadWriters"));
            localStorage.removeItem("loadWriters")
            this.setState({loadWriters:true});
        }else{
            this.rerender();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        let search = window.location.search;
        let params = new URLSearchParams(search).get('job');
        if (!params && prevState.loadWriters === true) {
            this.rerender();
        }
      }

    changePage = page => {
        if (this.state.search === true) {
            writerSearch(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else {
            getWriterRecords(0,page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };
    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };

    render() {
        const user = this.state.meta;
        return (
            <Fragment>
                <Header></Header>
                <div>
                  {/* <section className="dashboard-nav">
		                <div className="container employer-container">
		            	    <div className="head">
		            		    <h1 className="text-white">Welcome back,  { user.first_name }!</h1>
		            			<h2>Let's find you some great writers.</h2>
		            		</div>
							<AccountNav></AccountNav>
		            	</div>
		          </section> */}
                  <section className="jobsDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-15">
                    <div className="container employer-container">
                        <div className="row">
                          {/* <div className="col-12 col-xl-4 col-md-4">
                            <DashboardLeftPanel></DashboardLeftPanel>
                          </div> */}
                          <div className="col-12 col-xl-12 col-md-12">
                              <div className="header">
                              <div className="header-body">
                                <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                    My Writers
                                                </h1>
                                                <h6 className="header-pretitle">
                                                    Overview all available Jobs
                                                </h6>
                                            </div>
                                            
                                </div>
                             </div>
                             </div>
                             <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <form
                                                    onSubmit={this.submitSearch}
                                                    className="row align-items-center"
                                                >
                                                    <div className="col-auto pr-0">
                                                        <span className="fe fe-search text-muted"></span>
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            onChange={this.onQueryChange.bind(
                                                                this
                                                            )}
                                                            value={
                                                                this.state.query
                                                            }
                                                            type="search"
                                                            className="form-control form-control-flush search"
                                                            placeholder="Search"
                                                        ></input>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <table className="table table-sm table-nowrap card-table custom-employer-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="">
                                                                #
                                                            </div>
                                                        </th>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Profile Link</th>
                                                        {/* <th>Date</th> */}
                                                        {/* <th>Status</th> */}
                                                        {/* <th className="Options">
                                                            Options
                                                        </th> */}
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <List
                                                                    history={
                                                                        this
                                                                            .props
                                                                            .history
                                                                    }
                                                                    getItem={
                                                                        this
                                                                            .record
                                                                    }
                                                                    update={
                                                                        this
                                                                            .update
                                                                    }
                                                                    delete={
                                                                        this
                                                                            .delete
                                                                    }
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                    rerender={
                                                                        this
                                                                            .rerender
                                                                    }
                                                                ></List>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    <div>
                                        <Footer
                                            changePage={this.changePage}
                                            totalPages={this.state.meta.pages}
                                            curentPage={this.state.meta.page}
                                        ></Footer>
                                    </div>
                             </div>
                          </div>
                        </div>
                    </div>
                  </section>
                </div>
                {/* <div className="main-content mt-6">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="header">
                                    <div className="header-body">
                                        
                                        <div className="row align-items-center">
                                            <div className="col"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <form
                                                    onSubmit={this.submitSearch}
                                                    className="row align-items-center"
                                                >
                                                    <div className="col-auto pr-0">
                                                        <span className="fe fe-search text-muted"></span>
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            onChange={this.onQueryChange.bind(
                                                                this
                                                            )}
                                                            value={
                                                                this.state.query
                                                            }
                                                            type="search"
                                                            className="form-control form-control-flush search"
                                                            placeholder="Search"
                                                        ></input>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <table className="table table-sm table-nowrap card-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="custom-control custom-checkbox table-checkbox">
                                                                #
                                                            </div>
                                                        </th>
                                                        <th>Title</th>
                                                        <th>Applicants</th>
                                                        <th>Date</th>
                                                        <th>Status</th>
                                                        <th className="Options">
                                                            Options
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <List
                                                                    history={
                                                                        this
                                                                            .props
                                                                            .history
                                                                    }
                                                                    getItem={
                                                                        this
                                                                            .record
                                                                    }
                                                                    update={
                                                                        this
                                                                            .update
                                                                    }
                                                                    delete={
                                                                        this
                                                                            .delete
                                                                    }
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></List>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    <div>
                                        <Footer
                                            changePage={this.changePage}
                                            totalPages={this.state.meta.pages}
                                            curentPage={this.state.meta.page}
                                        ></Footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </Fragment>
        );
    }
}
Writers.contextType = AppContext;
export default Writers;



// WEBPACK FOOTER //
// ./src/components/employer/writers/Writers.js